import i18next from "i18next";

// To add a route add it to enRoutes and frRoutes
export const enRoutes: {[key: string]: string} = {
  login: "/en/login/:invite",
  root: "/en",
  userInfo: "/en/userInfo",
  employeeInfo: "/en/employeeInfo",
  banking: "/en/banking",
  submit: "/en/submit",
  success: "/en/success",
  failed: "/en/failed"
};

export const frRoutes: {[key: string]: string} = {
  login: "/fr/ouverture/:invite",
  root: "/fr",
  userInfo: "/fr/utilisateurInfo",
  employeeInfo: "/fr/employéInfo",
  banking: "/fr/bancaire",
  submit: "/fr/soumettre",
  success: "/fr/succes",
  failed: "/fr/manquee"
};

const getRouteMap = () => {
  const mappings: {[key: string]: string} = {};
  Object.keys(enRoutes).forEach((routeName) => {
    if (!frRoutes[routeName]) {
      throw new Error("Route definitions mismatch.");
    }
    mappings[enRoutes[routeName]] = frRoutes[routeName];
    mappings[frRoutes[routeName]] = enRoutes[routeName];
  });
  return mappings;
};

export const routeMap = getRouteMap();

export const getRoute = (key: string) => {
  return i18next.language === "en" ? enRoutes[key] : frRoutes[key];
};
